import * as React from "react";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { InlineActionButton } from "../../actionButton/ActionButton";

export interface IJobCreatedViewProps {
    allocateDistributionConfirmationClose?: () => void;
    hideModal:typeof hideModal;
    textToScreen?:string;
}

const JobCreatedView: React.SFC<IJobCreatedViewProps> = ({hideModal,textToScreen,allocateDistributionConfirmationClose}) => {
   

    const buttonCloseAction = () => {
        allocateDistributionConfirmationClose()
        hideModal();
    }
    return (
        <div style = {{'display': 'flex', 'flexDirection': 'column'}}>  
            <i className="ms-Icon ms-Icon--Completed" style={{color:'green',alignSelf: 'anchor-center',padding: '2vh',fontSize: '4em'}}/>       
            <div className="loadingView">
                <div className="loadingViewText" style={{color:'green'}} > {textToScreen} </div>
            </div>
            <div className="button-separator"></div>
            <div style = {{'display': 'flex', 'flexDirection': 'row','justifyContent': 'center', marginBottom: '16px'}}>
                <InlineActionButton
                buttonText="Close"
                buttonAction={buttonCloseAction}
                disabled={false}
                className="button btn-defaultPrimary" />
            </div>
            
            
        </div>
        
    );
};

export default JobCreatedView;